import { useCallback } from 'react';
import { UseFormReturn } from 'react-hook-form';

type GuestFormValues = {
  guests: {
    title: string;
    firstName: string;
    lastName: string;
    gender: string;
    [key: string]: unknown;
  }[];
  [key: string]: unknown;
};

type UseGuestCountChangeParams = {
  form: UseFormReturn<any>;
  defaultGender?: string;
};

export function useGuestCountChange({ form, defaultGender = '' }: UseGuestCountChangeParams) {
  return useCallback(
    (count: number) => {
      const current = (form.getValues('guests') as GuestFormValues['guests']) || [];
      let nextGuests = current;
      if (count > current.length) {
        nextGuests = [
          ...current,
          ...Array.from({ length: count - current.length }, () => ({
            title: '',
            firstName: '',
            lastName: '',
            gender: defaultGender,
          })),
        ];
      } else if (count < current.length) {
        nextGuests = current.slice(0, count);
      }
      form.setValue('guests', nextGuests, { shouldDirty: true });
    },
    [form, defaultGender]
  );
}
